import React from 'react';
import CommonField from './CommonField.jsx';
import ColorPicker from '../../../../common/ColorPicker/DashboardColorPicker.jsx';
import get from 'lodash/get';

function ColorPickerSetting(props) {
  const { attr, label, prefix = '', selectedObject, setAttribute, disabled = false, defaultValue } = props;
  const fullAttr = [prefix, attr].filter(Boolean).join('.');
  return (
    <CommonField label={label} {...props} attr={fullAttr}>
      <ColorPicker
        value={get(selectedObject, fullAttr) ?? defaultValue}
        onChange={v => setAttribute(fullAttr, v)}
        disabled={disabled}
      />
    </CommonField>
  )
}

export default ColorPickerSetting;